
import Vue, { PropType } from 'vue';

import Button from '~/components/builders/Base/Button.vue';
import ImportButton from '~/components/profile/components/ImportButton.vue';
import VerifiedBadge from '~/assets/img/verifiedBadge.png';
import PathImage from '~/assets/img/welcome/path.png';

import { User } from '~/services/IdentityService';
import { CandidateProfileScorer } from '~/utils/candidate/CandidateProfileScorer';

export default Vue.extend({
    name: 'WelcomeFinalPage',
    components: {
        Button,
        ImportButton,
    },
    props: {
        user: {
            type: Object as PropType<User>,
            required: true,
        },
        scorer: {
            type: Object as PropType<CandidateProfileScorer>,
            required: true,
        },
        flowCompleted: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            VerifiedBadge,
            PathImage,
        };
    },
    computed: {
        progress(): number {
            return this.scorer.getProfileScore().progress;
        },
    },
    methods: {
        handleCompleteProfile() {
            this.$router.replace(
                this.$URLS.profile,
                () => {
                    this.$emit('flowCompleted');
                },
                () => {
                    this.$emit('flowCompleted');
                }
            );
        },
        handleExploreJob() {
            this.$router.replace(
                this.$URLS.findjobs,
                () => {
                    this.$emit('flowCompleted');
                },
                () => {
                    this.$emit('flowCompleted');
                }
            );
        },
    },
});
